import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeSystemProvider } from '@amtrav/theme-system';

// This is the main entry point for the theme-system & ThemeSystemProvider 
// so that our themes are available to all of our React apps on AM5.

const { theme } = document.querySelector('body').dataset;

ReactDOM.render(<ThemeSystemProvider themeName={theme} />, document.getElementById('themeSystemTarget'));
